$(document).on('submit', '[data-sneakers-form]', (event) => {
  event.preventDefault();
  const $form = $(event.currentTarget);
  $form.addClass('mask mask--light');
  const $selectFields = $form.find('select');

  $selectFields.each(function () {
    $(this).removeClass('has-error');
  });

  const $emptySelects = $selectFields.filter(function () {
    return $(this).val() === '';
  });

  if ($emptySelects.length > 0) {
    $form.removeClass('mask mask--light');
    $emptySelects.addClass('has-error');
  } else {
    $.ajax({
      url: $form.attr('action'),
      method: 'POST',
      data: new FormData($form[0]),
      processData: false,
      contentType: false,
      success: (resp) => {
        $form.closest('[data-cms-form-container]').replaceWith(resp);
        if ($(this).data('cms-form') !== '') {
          window.dataLayer.push({
            event: `${$(this).data('cms-form')}_submit_success`,
          });
        }
      },
      error: () => {
        $form.removeClass('mask mask--light');
      },
    });
  }
});
